module.exports = __webpack_public_path__ + "img/blagajna.online.d43c9ac5.png";